/** @jsx jsx */
import { jsx } from '@emotion/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import * as S from './styles';

interface IChallengeSection {
  children: any;
  title: string | JSX.Element;
  defaultExpanded?: boolean;
  isDisabled?: boolean;
}

export default function ChallengeSection({
  children,
  title,
  defaultExpanded,
  isDisabled,
}: IChallengeSection) {
  return (
    <Accordion css={S.cssAccordion} defaultExpanded={defaultExpanded}>
      <S.AccordionSummary
        expandIcon={
          <S.IconButton isDisabled={isDisabled}>
            <ExpandMoreIcon fontSize="large" />
          </S.IconButton>
        }
      >
        <S.Title isDisabled={isDisabled}>{title}</S.Title>
      </S.AccordionSummary>
      <S.AccordionDetails>{children}</S.AccordionDetails>
    </Accordion>
  );
}

export function ChallengeSectionSkeleton() {
  return <Skeleton css={S.cssSkeleton} />;
}

export const ChallengeDescriptionSection = S.DescriptionSection;
